import axios from 'axios';
import Cookies from 'js-cookie';

const setAuthToken = token => {
  if (token) {
    axios.defaults.headers.common['x-auth-token'] = token;
    // Store token in secure cookie
    Cookies.set('token', token, {
      expires: 7, // 7 days
      secure: process.env.NODE_ENV === 'production', // Only use secure in production
      sameSite: 'strict',
      httpOnly: false // Set to true if you want extra security (but you'll need backend to handle)
    });
  } else {
    delete axios.defaults.headers.common['x-auth-token'];
    Cookies.remove('token');
  }
};

export default setAuthToken;